import CustomerStockList from "./CustomerStockList";

export default CustomerStockList;
